import { Injectable } from '@angular/core';
import { StorageBase } from '../../common/bases/storage-base';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService extends StorageBase {
  constructor() {
    super(sessionStorage);
  }

  setItem(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): any {
    const value = sessionStorage.getItem(key);
    return value === null ? null : JSON.parse(value);
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
